import HistoricBondCreatePage from "./components/HistoricBondCreatePage";
import useVABondCreateHistoric from "./hooks/useVABondCreateHistoric";
import VAHistoricBasicInformationForm from "./components/VAHistoricBasicInformationForm";
import VAHistoricGuardianForm from "./components/VAHistoricGuardianForm";
import VAHistoricAttorneyInformationForm from "./components/VAHistoricAttorneyInformationForm";
import { ObligeeInformationForm } from "./Helpers/ObligeeInformation";
import VAHistoricRequestorInformationForm from "./components/VAHistoricRequestorInformationForm";
import { BillingInformationForm } from "./Helpers/BillingInformation";
import VAHistoricOtherDetailsForm from "./components/VAHistoricOtherDetailsForm";
import VAHistoricBondNumberSection from "./components/VAHistoricBondNumberSection";

const VABondCreateHistoric = () => (
  <HistoricBondCreatePage
    bondKindLabel="VA"
    useCreateHook={useVABondCreateHistoric}
    sections={[
      { key: "basic", Component: VAHistoricBasicInformationForm, stateKey: "basicInformation" },
      { key: "guardian", Component: VAHistoricGuardianForm, stateKey: "guardianDetails" },
      { key: "attorney", Component: VAHistoricAttorneyInformationForm, stateKey: "attorneyInformation" },
      {
        key: "obligee",
        Component: ObligeeInformationForm,
        stateKey: "obligeeInformation",
        sectionProps: { bondType: "VA" },
      },
      { key: "requestor", Component: VAHistoricRequestorInformationForm, stateKey: "requestorInformation" },
      { key: "billing", Component: BillingInformationForm, stateKey: "billingInformation" },
      { key: "other", Component: VAHistoricOtherDetailsForm, stateKey: "otherDetails" },
      {
        key: "bondNumber",
        render: ({ globalState, updateGlobalState, errors }) => (
          <VAHistoricBondNumberSection
            data={globalState.otherDetails}
            updateData={(data) => updateGlobalState("otherDetails", data)}
            errors={errors}
          />
        ),
      },
    ]}
    submitDisabled={(globalState) => globalState?.basicInformation?.judgeStern === "No"}
  />
);

export default VABondCreateHistoric;
